import(/* webpackMode: "eager", webpackExports: ["EulaContent"] */ "/home/runner/work/breedlogic-frontend-api/breedlogic-frontend-api/deploy-artifact/src/components/TermsAndConditionsDialog/EulaContent.tsx");
